/* eslint-disable */
import { FormControlLabel, FormGroup, Grid, Switch, Typography } from "@mui/material";
import { MobXProviderContext } from "mobx-react";
import React, { useEffect } from "react";

function SwitchStatusEntregador(props) {
    const { entregadoresStore } = React.useContext(MobXProviderContext);
    const [checked, setChecked] = React.useState((props.entregador?.Ativo ?? 0) == 1 ? true : false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
        entregadoresStore.mudarStatusEntregador(props.entregador?.EntregadorId ?? -1, event.target.checked ? 1 : 0);
    };

    var height = window.innerHeight

    return (
        <div style={{ paddingTop: 20 }}>
            <FormGroup>
                <Typography variant="h5" component="div">
                    <Grid
                        component="label"
                        container
                        direction="column"
                        justifyContent="center"
                      alignItems="flex-end"
                    >
                        <Grid item>
                            <Switch
                                checked={checked}
                                onChange={handleChange}
                                color="primary"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Grid>
                        <Grid item style={{ paddingRight: 8 }}>{checked ? "Ativo" : "Desativado"}</Grid>
                    </Grid>
                </Typography>
            </FormGroup>

        </div>


    )
}

export default SwitchStatusEntregador;
